import { useNavigate, useSearch } from "@tanstack/react-router";
import { Lock, Mail, Palette, Shield, User } from "lucide-react";
import type { TabItem } from "@/components/common";
import { Tabs } from "@/components/common";
import { PageHeader } from "@/components/layout/PageHeader";
import { NotificationsTab } from "@/components/settings/NotificationsTab";
import { PersonalizationTab } from "@/components/settings/PersonalizationTab";
import { PrivacyTab } from "@/components/settings/PrivacyTab";
import { ProfileTab } from "@/components/settings/ProfileTab";
import { SecurityTab } from "@/components/settings/SecurityTab";
import { SettingsSidebar } from "@/components/settings/SettingsSidebar";
import { useProfile } from "@/hooks/useSettings";
import type { SettingsTab } from "@/types/settings";

const tabs: TabItem[] = [
  {
    id: "profile",
    label: "Profil",
    icon: <User size={18} aria-hidden="true" />,
  },
  {
    id: "security",
    label: "Bezpieczeństwo",
    icon: <Shield size={18} aria-hidden="true" />,
  },
  {
    id: "notifications",
    label: "Powiadomienia",
    icon: <Mail size={18} aria-hidden="true" />,
  },
  {
    id: "personalization",
    label: "Personalizacja",
    icon: <Palette size={18} aria-hidden="true" />,
  },
  {
    id: "privacy",
    label: "Prywatność",
    icon: <Lock size={18} aria-hidden="true" />,
  },
];

export function SettingsPage() {
  const { tab: activeTab } = useSearch({
    from: "/authenticated/settings",
  });
  const navigate = useNavigate();
  const { data: profile } = useProfile();

  return (
    <div className="animate-fade-in">
      <PageHeader
        title="Konfiguracja konta"
        description="Zarządzaj swoim kontem i preferencjami"
      />

      <div className="grid gap-6 lg:grid-cols-[280px_1fr]">
        <SettingsSidebar profile={profile} />

        <div>
          <Tabs
            tabs={tabs}
            activeTab={activeTab}
            onChange={(id) => {
              navigate({
                to: "/settings",
                search: { tab: id as SettingsTab },
                replace: true,
              });
            }}
          />

          <div className="mt-6">
            {activeTab === "profile" && <ProfileTab />}
            {activeTab === "security" && <SecurityTab />}
            {activeTab === "notifications" && <NotificationsTab />}
            {activeTab === "personalization" && <PersonalizationTab />}
            {activeTab === "privacy" && <PrivacyTab />}
          </div>
        </div>
      </div>
    </div>
  );
}
